import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    main: colors.indigo[500],
    light: colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200],

  // custom button color by dev team
  bprimary: {
    contrastText: white,
    main: '#007bff',
  },
  bsecondary: {
    contrastText: white,
    main: '#545b62',
  },
  bsuccess: {
    contrastText: white,
    main: '#28a745',
  },
  bdanger: {
    contrastText: white,
    main: '#dc3545',
  },
  bwarning: {
    contrastText: white,
    main: '#ffc107',
  },
  binfo: {
    contrastText: white,
    main: '#17a2b8',
  },
  blight: {
    contrastText: '#212529',
    main: '#f8f9fa',
  },
  bdark: {
    contrastText: white,
    main: '#343a40',
  },
  bbggray:{
    main:'#ecf0f5',
    contrastText: black,
  }
};
